<template>
  <base-modal
    :closeable-from-outside="false"
    hide-footer
    :size="'lg'"
    :modal-id="'fulfillment-detail'"
    @hidden="$emit('onCloseModal')"
    @show="fetchShippingData"
  >
    <b-form @submit.prevent="onSubmitModal">
      <b-tabs>
        <b-tab
          :title="'Information'"
          :title-link-class="['font-medium-5']"
          lazy
        >
          <fulfillment-information :form-data="formData" />
        </b-tab>
        <b-tab
          :title="'Address'"
          :title-link-class="['font-medium-5']"
          lazy
        >
          <fulfillment-address :disabled="!isAdjusted" :form-data="formData" />
        </b-tab>
        <b-tab
          :title="'Shipping'"
          :title-link-class="['font-medium-5']"
          lazy
        >
          <fulfillment-shipping
            :disabled="!isAdjusted"
            :form-data="formData"
            :status-tracking="statusTracking"
          />
        </b-tab>
      </b-tabs>
      {{isEdit}}
      {{isAdjusted}}
      <div class="row">
        <div class="col-12">
          <div class="modal-btn-wrp btn-wrp mt-2 mb-2">
            <div class="d-flex justify-content-center mt-2">
              <cancel-button
                class="mr-1"
                @click.native="$emit('onCloseModal')"
              />
              <save-button
                v-if="isAdjusted"
                type="submit"
                class="ml-1"
                :loading="loading"
              />
            </div>
          </div>
        </div>
      </div>
    </b-form>
  </base-modal>
</template>

<script>
import FulfillmentInformation from './component/tabs/FulfillmentInformation.vue'
import FulfillmentAddress from './component/tabs/FulfillmentAddress.vue'
import FulfillmentShipping from './component/tabs/FulfillmentShipping.vue'
import useShippingDetailModal from './hook/useShippingDetailModal'

export default {
  components: {
    FulfillmentInformation,
    FulfillmentAddress,
    FulfillmentShipping,
  },
  props: {
    dataObj: { type: Object, default: {} },
    isEdit: { type: Boolean, default: false },
    isAdjusted: { type: Boolean },
    loading: { type: Boolean, default: false },
  },

  setup(props, { emit }) {
    const {
      formData,
      optionData,
      loadingType,
      statusTracking,
      fetchShippingData,
      onSubmitModal,
      onInputNumber,
      onSelectStatus,
      onSearchTrackNo,
    } = useShippingDetailModal(props)

    // const {
    //   loading
    // } = useShippingDetail()

    return {
      formData,
      optionData,
      loadingType,
      statusTracking,
      fetchShippingData,
      onSubmitModal,
      onInputNumber,
      onSelectStatus,
      onSearchTrackNo,
      // loading
    }
  },
}
</script>

<style scope>
@import '~@/assets/css/override-styles/dynamic-fields.css';
@import '~@/assets/css/override-styles/tag-dropdown.css';
@import '~@/assets/css/pages/fulfillment/fulfillment-modal.css';
@import '~@/assets/css/override-styles/v-select.css';
</style>